import { useTranslation } from "react-i18next";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "../../../components/ui/alert-dialog";
import { Spinner } from "../../../components/ui/spinner";
import type { MouseEvent } from "react";

type DeleteProps = {
  blueprint: any | null;
  isDeleting: boolean;
  onCancel: () => void;
  onConfirm: (event: MouseEvent<HTMLButtonElement>) => void;
};
const DeleteBlueprint = ({
  blueprint,
  isDeleting,
  onCancel,
  onConfirm,
}: DeleteProps) => {
  const { t } = useTranslation();
  const open = blueprint !== null;

  return (
    <AlertDialog
      open={open}
      onOpenChange={(next) => {
        if (!next && !isDeleting) onCancel();
      }}
    >
      <AlertDialogContent className="min-w-0 max-w-[calc(100%-2rem)] border-border bg-card">
        <AlertDialogHeader className="min-w-0 max-w-full">
          <AlertDialogTitle className="text-foreground">
            {t("blueprints.deleteBlueprint")}
          </AlertDialogTitle>
          <AlertDialogDescription className="min-w-0 max-w-full break-words">
            {blueprint
              ? t("blueprints.deleteDescription", {
                  name:
                    blueprint.name.length > 50
                      ? `${blueprint.name.slice(0, 50)}...`
                      : blueprint.name,
                })
              : ""}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="min-w-0 max-w-full">
          <AlertDialogCancel
            className="max-w-full whitespace-normal break-words border-border bg-card text-foreground hover:bg-accent"
            disabled={isDeleting}
          >
            {t("common.discard")}
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={(event) => {
              event.preventDefault();
              onConfirm(event);
            }}
            disabled={isDeleting}
            aria-busy={isDeleting}
            className="max-w-full whitespace-normal break-words bg-destructive text-white hover:bg-destructive/90"
          >
            {isDeleting ? (
              <>
                <Spinner className="size-4" />
                <span>{t("common.deleting")}</span>
              </>
            ) : (
              t("common.delete")
            )}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default DeleteBlueprint;
